import React from "react";

function Passkey() {
    return (
        <div className="dialog_box">
            <h3>Passkey</h3>
        </div>
    );
}
export default (Passkey);
